import { ErrorHandler, Injectable } from '@angular/core';
import { AppInsightsService } from '@app/core/services/app-insights.service';

@Injectable()
export class AppInsightsErrorHandler extends ErrorHandler {
  constructor(private appInsightsService: AppInsightsService) {
    super();
  }

  override handleError(error: unknown): void {
    super.handleError(error);
    this.appInsightsService.trackException(error instanceof Error ? error : new Error(String(error)));
  }
}
